/*
	STATE
*/
//------------------------------------------------------------
// IMPORTS
//------------------------------------------------------------

import getters from './getters';
import fileSystems from '@/data/file_systems/';
import characters from '@/data/characters/';

//------------------------------------------------------------
// GAME STATE
// Stores all references to in-game items and concepts
// not readonly, if person dies - 'people' updates
//------------------------------------------------------------

const state = {
	characters: characters,
	// conversations: [],
	// emails: [],
	// files: [], // files like audio, images and text
	fileSystems: fileSystems,
	// gateways: [], // computers in the world
	// networks: [],
	// organizations: [],
	// websites: [], // or are these hosted elsewhere?
}
//------------------------------------------------------------
// EXPORT
//------------------------------------------------------------

export default {
	namespaced: true,
    state,
    getters
}